import api from '@mint-lib/api';
import { useQuery } from '@mint-lib/query-client';
import { getRouteApi } from '@mint/routing';
import { atom, useAtom, useSetAtom } from 'jotai';

import { CHECK_AVAILABLE_METRICS } from '../constants/EndpointConstants.js';
import { QueryKey } from '../constants/queryKeys.js';
import {
  CheckAvailableMetricsResponseSchema,
  MetricOptionItem,
} from '../types/predictivePlanning.js';
import { usePredictivePlanningMode } from './usePredictivePlanningMode.js';

const getAvailableMetrics = async (campaignId: string) => {
  const { data } = await api.post(CHECK_AVAILABLE_METRICS, {
    journey_id: campaignId,
  });
  return CheckAvailableMetricsResponseSchema.parse(data);
};

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const selectedKPIAtom = atom<string | null>(null);
const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);
const DEFAULT_METRIC_LIST: MetricOptionItem[] = [];

export const usePredictivePlanningMetricList = () => {
  const { campaignId } = routeApi.useParams();
  const isPredictivePlanning = usePredictivePlanningMode();

  const { data } = useQuery({
    queryKey: [QueryKey.CHECK_AVAILABLE_METRICS, { campaignId }],
    queryFn: () => getAvailableMetrics(campaignId),
    enabled: isPredictivePlanning,
    select: (data) =>
      data.availableMetrics.map((kpi) => ({
        value: kpi,
        label: capitalize(kpi),
      })),
  });

  return data ?? DEFAULT_METRIC_LIST;
};

export const useSelectedKPI = () => {
  return useAtom(selectedKPIAtom);
};

export const useSetSelectedKPI = () => {
  return useSetAtom(selectedKPIAtom);
};
